import { useGaugeState } from "@mui/x-charts/Gauge";
import { useTheme } from "@mui/material";
import {
  getColorByValue,
  VALUE_ANGLE_OFFSET,
} from "~/pages/space/home-dashboard/SpaceOrWorkspaceRiskCard/components/SpaceRiskGaugeChart/utils/spaceRiskGaugeChartUtils";

const SpaceRiskGaugeChartMainArc = ({ value }: { value: number }) => {
  const color = getColorByValue(value);
  const { startAngle, endAngle, outerRadius, cx, cy } = useGaugeState();
  const radius = outerRadius;
  const theme = useTheme();
  const angleRange = endAngle - startAngle;
  const valueAngle = startAngle + (value / 100) * angleRange;

  const arcId = `glow-arc-${color}`;
  const gradientId = `gradient-arc-${color}`;
  const width = `${100 - VALUE_ANGLE_OFFSET}%`;

  const drawArc = (
    from: number,
    to: number,
    stroke: string,
    withGlow: boolean = false,
  ) => {
    const startX = cx + radius * Math.sin(from);
    const startY = cy - radius * Math.cos(from);
    const endX = cx + radius * Math.sin(to);
    const endY = cy - radius * Math.cos(to);
    const largeArcFlag = to - from > Math.PI ? 1 : 0;

    return (
      <path
        d={`M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`}
        stroke={stroke}
        strokeWidth={19}
        fill="none"
        strokeLinecap="butt"
        filter={withGlow ? `url(#${arcId})` : undefined}
      />
    );
  };

  return (
    <svg
      width={width}
      height="100%"
      viewBox={`0 0 ${outerRadius * 2} ${outerRadius * 2}`}
      overflow="visible"
    >
      <defs>
        {/* Arc glow shadow */}
        <filter id={arcId} x="-100%" y="-100%" width="300%" height="300%">
          <feDropShadow
            dx="0"
            dy="0"
            stdDeviation="4"
            floodColor={theme.palette?.[color].light}
            floodOpacity="0.95"
          />
        </filter>

        {/* Gradient for active arc */}
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop
            offset="0%"
            stopColor={theme.palette?.[color].main}
            stopOpacity="1"
          />
          <stop
            offset="100%"
            stopColor={theme.palette?.[color].light}
            stopOpacity="0.4"
          />
        </linearGradient>
      </defs>

      {/* Inactive arc */}
      {drawArc(startAngle, endAngle, theme.palette.background.light)}

      {/* Active arc */}
      {drawArc(startAngle, valueAngle, `url(#${gradientId})`, true)}
    </svg>
  );
};

export default SpaceRiskGaugeChartMainArc;
